import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';


import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {setComponentState,setSidebarState} from '../../actions/Builder.js';
import SidebarSettingAccordion from './SidebarSettingAccordion.js';
import Slider, { Range } from 'rc-slider';
import SidebarElementSetting from './SidebarElementSetting.js';

import SidebarElementSpacing from './SidebarElementSpacing.js';
import SidebarElementWrapper from './SidebarElementWrapper.js';

import SidebarElementHeader from './SidebarElementHeader.js';

class Spacing extends React.Component {
	constructor(props) {	
		super(props);
		
		this.el = this.el.bind(this);	
		this.handleBackClick = this.handleBackClick.bind(this);
		this.onChange = this.onChange.bind(this);
	}


    el() {
    	return this.props.builder.components[this.props.id];
    }

    renderSettings() {
    	return <div><SidebarElementSpacing text='Settings' />Dette er en test</div>;
    }

    handleBackClick() {
    	this.props.setSidebarState({'visible':false});
    }

    onChange(v) {
    	this.props.setComponentState(this.el().id,{value:v+'px'});
    }

    render() {
    	if(this.props.sidebar == true) {
    		return(
	    		<div className="sidebar text" style={this.props.style}>
	    			<SidebarElementHeader handleBackClick={this.handleBackClick} text="Spacing" />
	    			
	    			<div className="panel-group panel-group-continuous" id="spacing-settings" aria-multiselectable="true" role="tablist">

	    				<SidebarSettingAccordion selectedSetting={false} optionKey="spacing" parent="spacing-settings" title="Spacing">
	    					<SidebarElementSetting text="Height">
				    			<Slider value={parseInt(this.el().value.toString().replace('px',''))}
										onChange={this.onChange} 
										min={10}
										max={400}
								      />
							</SidebarElementSetting>
						</SidebarSettingAccordion>
					</div>
 
	    		</div>
    		);
    	}else{
    		return (
	      		<div className="text main" style={{height:this.el().value}} />
	      );
    	}
      
    }
}
const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setComponentState,setSidebarState},dispatch)
}

Spacing = connect(mapStateToProps,mapDispatchToProps)(Spacing);

export default Spacing;





// WEBPACK FOOTER //
// ./components/builder/Spacing.js